










































































































































































































import Vue from 'vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import { mapActions } from 'vuex'
import { CreateShippingAddressInput } from '@/types/generated/graphql'
import prefectures from '@/packages/Prefectures'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import XTel from '@/components/atoms/Input/XTel.vue'
export default Vue.extend({
  name: 'ShippingAddressCreate',
  components: {
    XInput,
    XDropdown,
    XButton,
    XCard,
    XFormLabel,
    XZipInput,
    XTel,
  },
  data(this: { defaultShippingAddress: () => CreateShippingAddressInput }) {
    return {
      prefs: prefectures(),
      shippingAddressInput: this.defaultShippingAddress(),
      error: '',
      loading: false,
    }
  },
  computed: {
    prefOptions(): OptionEntry<number>[] {
      const options = this.prefs.map((e) => {
        return { value: e.id, label: e.name }
      })
      options.splice(0, 0, { value: -1, label: '' })
      return options
    },
  },
  methods: {
    ...mapActions('shippingAddress', ['register']),
    async onCreate() {
      await this.register(this.shippingAddressInput)
      await this.$router.push({ name: 'ShippingAddressList' })
    },
    defaultShippingAddress(): CreateShippingAddressInput {
      return {
        name: '',
        destinationName: '',
        zipCode: '',
        prefId: -1,
        address1: '',
        address2: '',
        phone: '',
        companyDepartment: '',
      }
    },
    setAddress(address: any) {
      this.shippingAddressInput.prefId = address.prefId
      this.shippingAddressInput.address1 = address.locality + address.street
    },
  },
})
